import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { CRUD_CREATE, useCreate, useTranslate } from 'ra-core';
import { SignUpForm } from './SignUpForm';
import { AuthenticationLayout } from '../AuthenticationLayout';
import { useLayer7Notify } from '../../useLayer7Notify';
export const SignUp = props => {
    const translate = useTranslate();
    const classes = useStyles(props);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [serverError, setServerError] = useState(null);
    const [signup] = useSignup();
    const handleSubmit = data => {
        signup(data, {
            onSuccess: () => setShowConfirmation(true),
            onFailure: error => {
                setServerError({ error });
            },
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h2", color: "textPrimary", className: classes.title }, translate('resources.registrations.title')),
        showConfirmation ? (React.createElement(SignUpConfirmation, Object.assign({}, props))) : (React.createElement(SignUpForm, Object.assign({ onSubmit: handleSubmit, serverError: serverError }, props)))));
};
/**
 * The page displaying the reset password form
 *
 * @param {*} Header A React Component used as the page header
 * @param {*} Content A React Component used to display some content next to the reset password form
 * @param {*} Footer A React Component used as the page footer
 *
 * @example <caption>Simple usage</caption>
 * <ResetPasswordPage />
 *
 * const MyApp = props => <Admin resetPasswordPage={MyResetPasswordPage} {...props} />
 *
 * @example <caption>With customized parts</caption>
 * const Header = () => <header><h1>My company</h1></header>
 * const Footer = () => <footer>Copyright © 2020 My Company. All Rights Reserved</footer>
 * const Content = () => <section><p>Welcome to My Product.</p></section>
 *
 * const MyResetPasswordPage = props => (
 *     <ResetPasswordPage
 *         Header={CustomHeader}
 *         Content={CustomContent}
 *         Footer={CustomFooter}
 *         {...props}
 *     />
 * );
 *
 * const MyApp = props => <Admin resetPasswordPage={MyResetPasswordPage} {...props} />
 */
export const SignUpPage = props => (React.createElement(AuthenticationLayout, Object.assign({}, props),
    React.createElement(SignUp, null)));
export const useSignup = () => {
    const [create, state] = useCreate('registrations');
    const notify = useLayer7Notify();
    const signup = (data, { onSuccess, onFailure }) => {
        create({
            payload: Object.assign({ FormField: '', Uuid: '{{GENERATED_GUID}}', OrganizationName: '', OrganizationDescription: '' }, data),
        }, {
            action: CRUD_CREATE,
            onSuccess: ({ data }) => {
                if (onSuccess) {
                    onSuccess();
                }
            },
            onFailure: error => {
                notify(error || 'resources.registrations.notifications.error', 'error');
                if (onFailure) {
                    onFailure(error);
                }
            },
        });
    };
    return [signup, state];
};
export const SignUpConfirmation = () => {
    const translate = useTranslate();
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { component: "p", variant: "h6", gutterBottom: true }, translate('resources.registrations.notifications.confirmation_title')),
        React.createElement(Typography, { variant: "body1", gutterBottom: true }, translate('resources.registrations.notifications.confirmation')),
        React.createElement(Typography, { variant: "body1" },
            React.createElement(Link, { component: RouterLink, to: "/login" }, translate('resources.registrations.actions.return_to_homepage')))));
};
const useStyles = makeStyles(theme => ({
    title: {
        fontSize: theme.typography.fontSize * 2,
        marginBottom: theme.spacing(6),
    },
}));
//# sourceMappingURL=SignUp.js.map